import React from 'react';
import { withRouter } from 'react-router';
import { ExamListContainer } from '../../containers';

const ExamListPage = () => <ExamListContainer />;

export default withRouter(ExamListPage);
